import NextLink from "next/link";
import Image from "next/image";
import { FaStar } from "react-icons/fa";
import { Button } from "@memento/ui/Button";

export function HowToCreateGroupVideo() {
  return (
    <div className="grid h-144 w-full grid-cols-1 grid-rows-5 items-center overflow-hidden rounded-2xl border border-gray-200 shadow-xl md:h-80 md:grid-cols-3 md:grid-rows-1">
      <div className="relative col-span-1 row-span-2 h-full overflow-hidden bg-teal-300">
        <Image
          src="/images/create-group-video/group-video-organizer-prompt.png"
          priority={true}
          alt="Group video organizer prompt"
          width="344"
          height="175"
          className="h-full w-full object-contain"
        />
      </div>
      <section className="col-span-1 row-span-3 space-y-4 px-8 md:col-span-2 md:row-span-1">
        <h2 className="font-sans text-lg font-semibold">
          How to Create a Group Video
        </h2>
        <div className="col-span-1 inline-grid gap-4">
          <div className="flex items-center space-x-2">
            <div className="inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gray-300">
              <div className="text-xs">1</div>
            </div>
            <div className="text-sm md:text-base">
              {"Set up your Group Video & Send Invites"}
            </div>
          </div>
          <div className="flex items-center space-x-2">
            <div className="inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-gray-300">
              <div className="text-xs">2</div>
            </div>
            <div className="text-sm md:text-base">{"Collect Clips"}</div>
          </div>
          <div className="flex items-center space-x-2">
            <div className="inline-flex h-6 w-6 items-center justify-center rounded-full bg-gray-300">
              <div className="text-xs">3</div>
            </div>
            <div className="text-sm md:text-base">
              {"Customize Your Group Video"}
            </div>
          </div>
        </div>
        <div className="flex space-x-2">
          <div className="inline-flex h-6 w-6 shrink-0 items-center justify-center rounded-full bg-red-700">
            <FaStar className="text-sm text-white" />
          </div>
          <div className="text-sm text-red-700 md:text-base">
            Surprise Someone Special!
          </div>
        </div>
        <div className="py-2 md:py-4">
          <NextLink href="/group-videos/new">
            <Button variant="primary">Create a Group Video</Button>
          </NextLink>
        </div>
      </section>
    </div>
  );
}
